/* ==========================================================================
   Sagheer Theme — Core JS
   بدون أي مكتبات خارجية. كل شيء vanilla و defer.
   ========================================================================== */
(function () {
  'use strict';

  const html = document.documentElement;
  const body = document.body;

  /* ----------------------------- Utilities ------------------------------ */
  const Theme = (window.Theme = window.Theme || {});

  Theme.formatMoney = function (cents) {
    const format = (window.theme && window.theme.settings.money_format) || '{{amount}}';
    const value = (cents / 100).toLocaleString('ar-EG', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    // نستبدل أي placeholder من صيغ Shopify بالقيمة المنسّقة
    return format.replace(/\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator|amount_with_period_separator)\s*\}\}/g, value);
  };

  Theme.toast = function (message) {
    const el = document.getElementById('Toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(el._timer);
    el._timer = setTimeout(() => {
      el.classList.remove('is-visible');
      setTimeout(() => { el.hidden = true; }, 300);
    }, 2600);
  };

  Theme.debounce = function (fn, wait) {
    let t;
    return function () {
      const args = arguments;
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };

  /* ------------------------- Overlay / scroll lock ---------------------- */
  let openLayers = 0;
  const overlay = document.getElementById('Overlay');

  function lockScroll() {
    openLayers += 1;
    body.classList.add('is-locked');
    if (overlay) overlay.classList.add('is-open');
  }
  function unlockScroll() {
    openLayers = Math.max(0, openLayers - 1);
    if (openLayers === 0) {
      body.classList.remove('is-locked');
      if (overlay) overlay.classList.remove('is-open');
    }
  }

  /* ------------------------------ Drawers -------------------------------- */
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  Theme.openDrawer = function (id, trigger) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer._trigger = trigger || document.activeElement;
    lockScroll();
    const first = drawer.querySelector(focusableSelector);
    if (first) setTimeout(() => first.focus(), 60);
    document.dispatchEvent(new CustomEvent('drawer:open', { detail: { id: id } }));
  };

  Theme.closeDrawer = function (id) {
    const drawer = document.getElementById(id);
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    unlockScroll();
    if (drawer._trigger && typeof drawer._trigger.focus === 'function') drawer._trigger.focus();
  };

  Theme.closeAll = function () {
    document.querySelectorAll('.drawer.is-open, .modal.is-open').forEach((el) => {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    openLayers = 0;
    body.classList.remove('is-locked');
    if (overlay) overlay.classList.remove('is-open');
  };

  Theme.openModal = function (id, trigger) {
    const modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    modal._trigger = trigger || document.activeElement;
    lockScroll();
    const first = modal.querySelector(focusableSelector);
    if (first) setTimeout(() => first.focus(), 60);
  };

  Theme.closeModal = function (id) {
    const modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    unlockScroll();
    if (modal._trigger && typeof modal._trigger.focus === 'function') modal._trigger.focus();
  };

  // فتح/إغلاق عبر data attributes
  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) {
      e.preventDefault();
      Theme.openDrawer(openBtn.getAttribute('data-drawer-open'), openBtn);
      return;
    }
    const closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) {
      e.preventDefault();
      const target = closeBtn.getAttribute('data-drawer-close');
      if (target) Theme.closeDrawer(target);
      else {
        const parent = closeBtn.closest('.drawer');
        if (parent) Theme.closeDrawer(parent.id);
      }
      return;
    }
    const modalBtn = e.target.closest('[data-modal-open]');
    if (modalBtn) {
      e.preventDefault();
      Theme.openModal(modalBtn.getAttribute('data-modal-open'), modalBtn);
      return;
    }
    const modalClose = e.target.closest('[data-modal-close]');
    if (modalClose) {
      e.preventDefault();
      const parent = modalClose.closest('.modal');
      if (parent) Theme.closeModal(parent.id);
      return;
    }
    if (e.target.id === 'Overlay') Theme.closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') Theme.closeAll();
    if (e.key !== 'Tab') return;
    const active = document.querySelector('.drawer.is-open, .modal.is-open');
    if (!active) return;
    const items = Array.prototype.filter.call(active.querySelectorAll(focusableSelector), (el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* --------------------------- Sticky header ---------------------------- */
  const headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper) {
    const setHeaderVar = () => {
      const h = headerWrapper.offsetHeight;
      html.style.setProperty('--header-height', h + 'px');
    };
    setHeaderVar();
    window.addEventListener('resize', Theme.debounce(setHeaderVar, 150));
    window.addEventListener('scroll', function () {
      headerWrapper.classList.toggle('is-scrolled', window.scrollY > 8);
    }, { passive: true });
  }

  /* ------------------------ Announcement rotator ------------------------ */
  document.querySelectorAll('[data-announcement]').forEach(function (wrapper) {
    const slides = wrapper.querySelectorAll('.announcement__slide');
    if (slides.length < 2) return;
    const speed = parseInt(wrapper.getAttribute('data-speed'), 10) || 5000;
    let i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, speed);
  });

  /* ------------------------------ Sliders -------------------------------- */
  document.querySelectorAll('[data-slider-nav]').forEach(function (nav) {
    const slider = document.getElementById(nav.getAttribute('data-slider-nav'));
    if (!slider) return;
    const isRTL = html.getAttribute('dir') === 'rtl';
    nav.querySelectorAll('[data-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const step = slider.clientWidth * 0.8;
        let delta = btn.getAttribute('data-dir') === 'next' ? step : -step;
        if (isRTL) delta = -delta;
        slider.scrollBy({ left: delta, behavior: 'smooth' });
      });
    });
  });

  /* ---------------------------- Reveal on scroll ------------------------- */
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    if (prefersReduced || !('IntersectionObserver' in window) || !(window.theme && window.theme.settings.animations)) {
      reveals.forEach((el) => el.classList.add('is-visible'));
    } else {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      reveals.forEach((el) => io.observe(el));
    }
  }

  /* ------------------------- Quantity components ------------------------- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const wrap = btn.closest('.qty');
    const input = wrap && wrap.querySelector('input');
    if (!input) return;
    const step = btn.getAttribute('data-qty-change') === 'up' ? 1 : -1;
    const min = parseInt(input.getAttribute('min'), 10) || 0;
    const next = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------- Accordion: مجموعة واحدة مفتوحة ------------------- */
  document.querySelectorAll('[data-accordion-group]').forEach(function (group) {
    group.querySelectorAll('details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        group.querySelectorAll('details').forEach(function (other) {
          if (other !== details) other.open = false;
        });
      });
    });
  });

  /* --------------------------- Share button ------------------------------ */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-share]');
    if (!btn) return;
    const url = btn.getAttribute('data-share') || window.location.href;
    if (navigator.share) {
      navigator.share({ title: document.title, url: url }).catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () {
        Theme.toast(btn.getAttribute('data-copied-text') || 'تم نسخ الرابط');
      });
    }
  });
})();
